import React from "react";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import { addClassName } from "../../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../../Utils/calculate-progress.js";
import Button from "../../../../Utils/Button/index";
import OpPopover from "../../../PopOver/Popover";
import info_black_24dp from "../../../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../../../../Dashboard/My-assessments/popover-inner-content";
import "./Reports-Table.css";
import completed from "../../../../../images/new-images/completed.png";
import { Link } from "react-router-dom";
import { LoaderComp } from "../../../../../_components/common/LoaderComp/Loadercomp.js";

const CompletedReportsTable = (props) => {
  const { isLoading, completedReports } = props;
  const isAuthParticipant = localStorage.getItem("is_auth_participant");
  

  if (isLoading || completedReports === undefined) {
    return <LoaderComp />; 
  }


  return (
    <React.Fragment>
      {completedReports.length == 0 ? (
        <h1 className="no-reports">There are no reports avaliable</h1>
      ) : (
        <div className="Responsive-My-Reports">
          {completedReports.map((assessment, index) => {
            return (
              <React.Fragment key={index}>
                <Row style={{ height: "2.5em" }}>
                  <img
                    className="assessmentIcon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      assessment.instrument__instrument_image
                    }
                  />
                  <div className="assessmentName">
                    {assessment.instrument__dashboard_header_text}
                  </div>
                  <OpPopover
                    positions={["right"]}
                    align={"center"}
                    targtElement={
                      <img className="infoIcon" src={info_black_24dp} />
                    }
                    isOpen={props.isPopOverOpenAssessmentId === assessment.id}
                    setOpen={(bool) => {
                      props.handleAssessmentPopOver(
                        bool ? assessment.id : false
                      );
                    }}
                  >
                    <Renderpopoverinnercontent
                      handleClosePopOver={props.handleClosePopOver}
                      assessmentheading={
                        assessment.instrument__dashboard_header_text
                      }
                      assesmentdescription={
                        assessment.instrument__dashboard_header_description
                      }
                    />
                  </OpPopover>
                  <i
                    onClick={() => props.toggleCollapse(assessment.id)}
                    className={props.collapseID === assessment.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true"
                  />
                </Row>
                <Row className="userName">
                  <p>
                    {assessment.participant__full_name}'s{" "}
                    {assessment.instrument__instrument_name}
                  </p>
                </Row>
                <hr />
                <Collapse isOpen={props.collapseID === assessment.id}>
                  <CardBody>
                    <Row>
                      <Col className="title">Date Of Expiry</Col>
                      <Col className="details">
                        {formatDate(assessment.expiry_date)}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Status</Col>
                      <Col className="details">
                        {assessment.assessment_status__status_name ===
                        "In progress" ? (
                          <div
                            style={{ display: "flex" }}
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            {calcPercentage(
                              assessment.assessment_number_count,
                              assessment.assessment_completed_count
                            )}
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Report in review" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Action</Col>
                      <Col className="details">
                        {assessment.assessment_status__status_name ===
                          "Completed" ||
                        assessment.assessment_status__status_name ===
                          "Report in review" && isAuthParticipant==='false' ? (
                          <Link
                            to={{
                              pathname: `/new/app/reportdownload/${assessment.id}/${assessment.participant__id}`,
                            }}
                          >
                            <Button type="submit">VIEW REPORT</Button>
                          </Link>
                        ) : assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <Link to="/new/app/questionnaire">
                            <Button type="resume">Resume</Button>
                          </Link>
                        ) : (
                          <Button type="disabled report">VIEW REPORT</Button>
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Collapse>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};
export default CompletedReportsTable;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/My-Reports/Responsive/Completed-Reports-Table.jsx